import IResult, { ResultType } from './IResult';

export default class NoResponseResult<T> implements IResult<T> {
    data: T | undefined;
    resultType: ResultType = 'NoResponse';
    errors: string[];

    constructor() {
        this.errors = ['The server did not respond.'];
    }
}
